import { createSelector } from 'reselect';
import get from 'lodash/get';

import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export const loadingSelector = createSelector(selector,
  avlIntState => ({
    loading: avlIntState.isFetching,
    showError: avlIntState.errorCode !== 0,
    errorMsg: avlIntState.errorMsg,
  }));

export const dataSelector = createSelector(selector,
  avlIntState => (avlIntState.response ? avlIntState.response.data : {}));

export const avlIntDataSelector = createSelector(
  dataSelector,
  partnerData => partnerData,
);

export default selector;
